import { QantasRewardsModel, QBRMemberJoinModel } from './../models/QantasRewardsModel';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class QantasRewardsService {
  baseUrl = 'api/QantasRewards';

  constructor(
    private http: HttpClient
  ) { }


  ABRLookup(abnNumber: string): Observable<any> {
    return this.http.get<string>(`${this.baseUrl}/ABRLookup?abnNumber=${abnNumber}`);
  }

  QBRAccountStatus(abnNumber: string): Observable<string> {
    return this.http.get<string>(`${this.baseUrl}/QBRAccountStatus?abnNumber=${abnNumber}`);
  }

  GetIdentityToken(): Observable<string> {
    return this.http.get<string>(`${this.baseUrl}/GetIdentityToken`);
  }

  QBRMemberJoin(model: QBRMemberJoinModel): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/QBRMemberJoin`, model);
  } 
}
